import { createReducer, on } from '@ngrx/store';
import * as StateActions from './state-items.actions';
import { StateItemsState } from './state-items.state';

const initialState: StateItemsState = {
  states: {}
};

export const stateReducer = createReducer(
  initialState,
  on(StateActions.createStateSuccess, (state, { key, historyItems }) => {
    const newState = state.states[key] ?? { updates: [], stateHistoryMap: {} };

    const updatedMap = { ...newState.stateHistoryMap };
    const newUpdates = [];

    historyItems.forEach((item) => {
      if (!updatedMap[item.id]) {
        updatedMap[item.id] = item;
        newUpdates.push(item);
      }
    });

    return {
      ...state,
      states: {
        ...state.states,
        [key]: {
          updates: newUpdates,
          stateHistoryMap: updatedMap
        }
      }
    };
  }),
  on(StateActions.updateStatesSuccess, (state, { key, historyItems }) => {
    const keys = Object.keys(state.states);
    const newStates = {};
    keys.forEach((k) => {
      if (k.includes(key)) {
        const existing = state.states[k] ?? { updates: [], stateHistoryMap: {} };

        const updatedMap = { ...existing.stateHistoryMap };
        const newUpdates = [];

        for (const item of historyItems) {
          if (!updatedMap[item.id]) {
            updatedMap[item.id] = item;
            newUpdates.push(item);
          }
        }
        newStates[k] = {
          updates: newUpdates,
          stateHistoryMap: updatedMap
        };
      }
    });

    return {
      ...state,
      states: {
        ...state.states,
        ...newStates
      }
    };
  })
);
